export default "__VITE_ASSET__$9MI_zPV__"